import type { MixpanelUserPropertyNames } from './Mixpanel.types';

export const MIXPANEL_USER_PROPERTY_NAMES: MixpanelUserPropertyNames = {
  name: '$name',
  email: '$email',
  trackingUuid: '$braze_external_id',
};
